<template>
  <el-dialog
    center
    width="600px"
    :title="dialogTitle"
    :visible.sync="dialogFormVisible"
    @close="resetFrom('editForm')"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item
        label="广告标题"
        :label-width="formLabelWidth"
        prop="adName"
      >
        <el-input v-model="editForm.adName" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="所属城市"
        :label-width="formLabelWidth"
        prop="areaId"
      >
        <el-cascader
          :options="areaAllList | filterList(areaAllList)"
          placeholder="请选择城市归属省份"
          v-model="editForm.areaId"
          :label-width="formLabelWidth"
          :props="{ checkStrictly: true }"
          clearable
        >
        </el-cascader>
      </el-form-item>

      <el-form-item
        label="广告位置"
        :label-width="formLabelWidth"
        prop="positionId"
      >
        <el-select v-model="editForm.positionId" placeholder="请选择">
          <el-option
            v-for="item in positionData"
            :key="item.positionId"
            :label="item.name"
            :value="item.positionId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="广告图片"
        :label-width="formLabelWidth"
        prop="picture"
      >
        <el-upload
          class="avatar-uploader"
          :action="actionUrl"
          :show-file-list="false"
          :http-request="httpRequest"
        >
          <img v-if="editForm.picture" :src="editForm.picture" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="图片标签"
        :label-width="formLabelWidth"
        prop="pictureAlt"
      >
        <el-input v-model="editForm.pictureAlt" autocomplete="off"></el-input>
      </el-form-item>
      <!-- 广告类型：adType   -1:非浮窗广告 0:小广告 1:长广告
 -->
      <!-- <el-form-item
        label="广告类型"
        :label-width="formLabelWidth"
        prop="adType"
      >
        <el-select v-model="editForm.adType" placeholder="请选择">
          <el-option
            v-for="item in adTypes"
            :key="item.id"
            :label="item.lable"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item
        label="广告链接"
        :label-width="formLabelWidth"
        prop="houseId"
      >
        <!-- <el-input v-model="editForm.href" autocomplete="off"></el-input> -->
        <el-select v-model="editForm.houseId" placeholder="请选择" clearable>
          <el-option
            v-for="item in link"
            :key="item.houseId"
            :label="item.title"
            :value="item.houseId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="开始时间"
        :label-width="formLabelWidth"
        prop="startTime"
      >
        <el-date-picker
          v-model="editForm.startTime"
          type="date"
          autocomplete="off"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item
        label="结束时间"
        :label-width="formLabelWidth"
        prop="endTime"
      >
        <el-date-picker
          v-model="editForm.endTime"
          type="date"
          autocomplete="off"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>

      <el-form-item
        label="排序号"
        :label-width="formLabelWidth"
        prop="sortIndex"
      >
        <el-input-number
          v-model="editForm.sortIndex"
          :min="1"
          :max="99999"
          label="最大越排前"
          autocomplete="off"
        ></el-input-number>
      </el-form-item>

      <div class="tooBox">
        <el-form-item
          label="是否开启"
          :label-width="formLabelWidth"
          prop="isOpen"
        >
          <el-switch
            v-model="editForm.isOpen"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
        <el-form-item
          label="是否推荐"
          :label-width="formLabelWidth"
          prop="isRecommend"
        >
          <el-switch
            v-model="editForm.isRecommend"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
      </div>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          resetFrom('editForm');
          dialogFormVisible = false;
        "
        >取 消</el-button
      >
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formData, formRules } from '../form.js';
import { bannerAdd, bannerEdit, bannerUpload } from '@/api/bannerApi.js'; //
import { mapGetters } from 'vuex';
export default {
  name: 'editBanner',
  data() {
    return {
      adId: '',
      dialogTitle: '',
      dialogFormVisible: false,
      editForm: { ...formData },
      editRules: formRules,
      formLabelWidth: '120px',
      imageUrl: '',
      actionUrl: '',
      link: [],
      adTypes: [],
    };
  },
  inject: ['reload'],
  computed: {
    ...mapGetters(['areaAllList']),
  },
  props: ['positionData', 'areaData'],
  mounted() {
    // this.getBannerLink();
  },
  methods: {
    resetFrom() {
      this.editForm = {};
    },
    async submitEdit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!');
          this.editForm.areaId =
            this.editForm.areaId.length === 3
              ? this.editForm.areaId[2]
              : this.editForm.areaId;
          // console.log('城市：', this.editForm.areaId);
          if (this.editForm.areaId.constructor === Array)
            return this.$message.error('请选择完整的城市');
          if (this.adId != '') {
            await bannerEdit(this.adId, { ...this.editForm }).then((res) => {
              if (res.code === 200) {
                this.$message.success('编辑成功!');
              } else {
                this.$message.error('编辑失败!');
                return;
              }
            });
          } else {
            console.log('editForm', new Date(this.editForm.endTime));
            await bannerAdd({ ...this.editForm }).then((res) => {
              if (res.code === 200) {
                this.$message.success('新增成功!');
              } else {
                this.$message.error('新增失败!');
                return;
              }
            });
          }
          this.dialogFormVisible = false;
          this.editForm = {};
          // 重新获取数据
          this.reload();
        });
      } catch (err) {
        window.console.log(err);
      }
    },
    httpRequest(options) {
      let file = [];
      file.push(options.file);
      const formdata = new FormData();
      formdata.append('file', options.file);
      bannerUpload(formdata)
        .then((res) => {
          this.$set(this.editForm, 'picture', res.data);
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  min-height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 150px;
  display: block;
}
</style>
